import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as accountSelectors from 'data/accounts/selectors';
import * as accountActions from 'data/accounts/actions';
import DownshiftField from 'components/QuickenControls/DownshiftField';

class AccountField extends PureComponent {

  constructor(props) {
    super(props);

    if (this.props.accountsLoadPending) {
      this.props.dispatchGetAccountsAction();
    }
  }

  render() {
    const accountsSorted = this.props.accounts && this.props.accounts.sort((item1, item2) => item1.name.localeCompare(
      item2.name,
      undefined,
      { numeric: true, sensitivity: 'base' },
    ));
    return (
      <DownshiftField
        dataLoading={this.props.accountsLoadPending}
        items={[...(accountsSorted && accountsSorted.values())]}
        initialItemSelected={this.props.initialAccount}
        onSelected={this.props.onSelected}
        textFieldProps={this.props.textFieldProps}
        itemToString={(account) => account ? account.name : ''}
        itemKey={(account) => account ? account.id : ''}
        lightWeight={this.props.lightWeight}
        autoFocus={this.props.autoFocus}
        indexId
      />
    );
  }

}

AccountField.propTypes = {
  accounts: PropTypes.object,
  initialAccount: PropTypes.object,
  onSelected: PropTypes.func,
  dispatchGetAccountsAction: PropTypes.func,
  accountsLoadPending: PropTypes.bool,
  textFieldProps: PropTypes.object,
  lightWeight: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  const accounts = ownProps.accounts || accountSelectors.getScheduledTransactionAccounts(state);
  return {
    accounts,
    accountsLoadPending: accountSelectors.getLoadPending(state),
    initialAccount: accounts && ownProps.initialAccountId ? accounts.get(ownProps.initialAccountId) : undefined,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetAccountsAction: () => dispatch(accountActions.getAccounts()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountField);
